import type { Org, Role } from "../api/types.ts"

export type IntakeOrgChoice = {
  /** 접수 화면에 화주 칸을 보일지. */
  needsOrg: boolean
  /** 처음 골라 둘 화주. 고를 수 있는 화주가 하나뿐일 때만 정한다. */
  defaultOrgId: number | null
}

/**
 * 접수를 등록할 때 화주를 골라야 하는가.
 *
 * 화주 계정은 서버가 언제나 자기 화주로 저장하므로 칸이 없다. 관리자는 화주를 보내야 하고
 * 빠뜨리면 서버가 ORG_REQUIRED 로 막는다(server/src/services/case-service.ts).
 */
export function intakeOrgChoice(role: Role, orgs: readonly Pick<Org, "id">[]): IntakeOrgChoice {
  if (role === "shipper") return { needsOrg: false, defaultOrgId: null }
  return { needsOrg: true, defaultOrgId: orgs.length === 1 ? orgs[0].id : null }
}

/** 화면 언어에 맞는 화주 이름. */
export function orgLabel(org: Pick<Org, "nameKo" | "nameJa">, locale: "ko" | "ja"): string {
  return locale === "ja" ? org.nameJa : org.nameKo
}
